import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class StrateSeasonsTabsComponent {
    static swiperInstance
    static isAjaxRunning = false
    static elementTargetName = 'seasons-tab'

    constructor() {
        const tabSelector = `[data-trigger="${StrateSeasonsTabsComponent.elementTargetName}"]`
        let previousActiveTab = $('.strate--seasons').data('current-tab')

        StrateSeasonsTabsComponent.cardsSlider()

        $(tabSelector).on('click', function () {
            const activeTab = $(this).data('tab-id')

            if (previousActiveTab === activeTab) return

            if (!StrateSeasonsTabsComponent.isAjaxRunning) {
                StrateSeasonsTabsComponent.isAjaxRunning = true
                StrateSeasonsTabsComponent.ajaxContent(activeTab)

                $(tabSelector).removeClass('active')
                $(this).addClass('active loading')
                previousActiveTab = activeTab
            }
        })
    }

    static ajaxContent(tabId) {
        const contentWrapperSelector = `[data-ajax-element="${StrateSeasonsTabsComponent.elementTargetName}"]`
        const $contentWrapper = $(contentWrapperSelector)

        $contentWrapper.addClass(`loading loading--${tabId}`)

        $.ajax({
            url: IRISCollectionCustomer.ajaxUrl,
            type: 'post',
            data: {
                action: 'get_home_seasons_tab',
                tab: tabId,
            },
            success(result) {
                const parsedResult = JSON.parse(result)
                setTimeout(() => {
                    StrateSeasonsTabsComponent.swiperInstance.destroy()

                    $(`${contentWrapperSelector}[data-element='seasons-highlight']`).html(
                        parsedResult.highlight,
                    )
                    $(`${contentWrapperSelector}[data-element='seasons-cards']`).html(
                        parsedResult.cards,
                    )
                    import(
                        '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                    ).then(({ HcLazyload }) => {
                        HcLazyload.update()
                    })

                    StrateSeasonsTabsComponent.cardsSlider()

                    setTimeout(() => {
                        $contentWrapper.removeClass(`loading loading--${tabId}`)
                    }, 250) // +750ms in strate-3-seasons.scss
                }, 500)

                $(`[data-trigger="${StrateSeasonsTabsComponent.elementTargetName}"]`).removeClass(
                    'loading',
                )
                StrateSeasonsTabsComponent.isAjaxRunning = false
            },
            error(error) {
                $contentWrapper.html('⚠️')
                console.error(error)

                $(`[data-trigger="${StrateSeasonsTabsComponent.elementTargetName}"]`).removeClass(
                    'loading',
                )
                StrateSeasonsTabsComponent.isAjaxRunning = false
            },
        })

        console.groupEnd()
    }

    swiperInstance

    static async cardsSlider() {
        const swiperContainerSelector = '[data-element="seasons-cards"]'

        if ($(swiperContainerSelector).length > 0) {
            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                grabCursor: true,
                spaceBetween: 10,
                slidesPerView: 2,
                navigation: {
                    prevEl: '#strate--seasons__slider-arrow-prev',
                    nextEl: '#strate--seasons__slider-arrow-next',
                },
                breakpoints: {
                    0: {
                        spaceBetween: 10,
                        slidesPerView: 2,
                    },
                    1000: {
                        spaceBetween: 40,
                        slidesPerView: 1.5,
                    },
                    1456: {
                        spaceBetween: 40,
                        slidesPerView: 2,
                    },
                },
                on: {
                    destroy: () => {
                        const $oldSlides = $(`${swiperContainerSelector} .swiper-slide`)
                            .removeAttr('role')
                            .removeAttr('aria-label')
                            .unwrap() // Revert the .wrapAll() before init
                            .removeClass('swiper-slide') // Revert the class added to each slide before init
                    },
                },
            }

            // needed wrapper
            $(`${swiperContainerSelector}> *`)
                .addClass('swiper-slide')
                .wrapAll(`<div class="swiper-wrapper"></div>`)

            StrateSeasonsTabsComponent.swiperInstance = await Swiper.create(
                swiperContainerSelector,
                options,
            )
        }
    }
}
